import * as types from '../actiontypes';
import Env from './../../util/env';

export function benefitServiceIntegrationAction(benefitId, engagementId) {
	return {
		type: types.BENEFIT_SERVICE_INTEGRATION,
		meta: {
			benefits: {
				method: 'POST',
				url: Env.getBenefitServiceUrl(),
				data: {
					benefitId: benefitId,
					engagementId: engagementId
				}
			}
		}
	};
}
